import { Link } from "@/atoms"
import { EXTERNAL_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { InformationPopover } from "@/molecules/InformationPopover"
import { TextSkeleton } from "@/molecules/TextSkeleton"
import { PopoverCard } from "../PopoverCard"

import styles from "./EnvironmentCard.module.scss"

import type { PropsWithChildren } from "react"
import type { EnvironmentCardProps } from "./EnvironmentCard.types"

export const Component = (props: Pick<EnvironmentCardProps, "id" | "name">) => (
  <div className={styles.text}>{props.name}</div>
)

export const PopoverEnvironmentCard = (
  props: PropsWithChildren & EnvironmentCardProps
) => {
  const { name, applications, children, detectedIncidentsCount } = props
  const { t: tGeneral } = useTranslation("translation", {
    keyPrefix: "general"
  })
  const { t: tManagement } = useTranslation("translation", {
    keyPrefix: "triage.adr.management"
  })
  const appCount = applications?.length || 0

  return (
    <InformationPopover.Popover
      content={
        <PopoverCard
          name={name}
          description={`${tGeneral("environment_one")}:`}
          aside={
            props.isMonitoringAdr ? (
              <TextSkeleton>{tManagement("learning")}</TextSkeleton>
            ) : (
              tManagement("notMonitoring")
            )
          }
          list={[]}
          subTitle={`${tGeneral("app", { count: appCount })}:`}
          subList={applications}
          placeholder={
            applications.length === 0 && (
              <div className={styles.noApps}>
                {props.isMonitoringAdr && (
                  <span>{tManagement("noAppsDetected")}</span>
                )}
                {!props.isMonitoringAdr && (
                  <>
                    {!!detectedIncidentsCount && (
                      <>
                        <span>{tManagement("environmentIsOffline.line1")}</span>
                        <span>{tManagement("environmentIsOffline.line2")}</span>
                      </>
                    )}
                    {!detectedIncidentsCount && (
                      <>
                        <span>{tManagement("sensorActive.line1")}</span>
                        <span>{tManagement("sensorActive.line2")}</span>
                        <Link
                          href={`${EXTERNAL_ROUTES.API_DOCS}/triage/incidents-adr-overview/enabling-incidents-adr`}
                          target="_blank"
                          className={styles.link}
                        >
                          {tManagement("sensorActive.link")}
                        </Link>
                      </>
                    )}
                  </>
                )}
              </div>
            )
          }
          Component={Component}
        />
      }
    >
      <span>{children}</span>
    </InformationPopover.Popover>
  )
}
